import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Template } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useEditTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (templateData: Partial<Template>): Promise<Template> => {
      const { data } = await request({
        path: `template`,
        method: 'PATCH',
        authenticate: true,
        dataObject: templateData,
      });

      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['admin-templates'] });
      queryClient.invalidateQueries({ queryKey: ['template', data._id] });
      toast.success('Template edited successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error editing template!');
    },
  });
};
